// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.grid_V5Y_x {
  
    display : grid;
    grid-template-columns: auto 1fr;
    column-gap : var( --size-padMedium, 16px );
    row-gap : var( --size-padMedium, 16px );
    align-items: center;
    justify-content: left;
  }
  
  .fill_ot9Gp {
    grid-column: 1 / span 2;
  }
  
  .sub__0AyV {
    padding : var( --size-padMedium, 16px ) var( --size-padXLarge, 32px );
  }`, "",{"version":3,"sources":["webpack://./../../node_modules/@leverege/ui-attributes/lib/export/shared/exportFormatter/ExportFormatterEditor.css"],"names":[],"mappings":";AACA;;IAEI,cAAc;IACd,+BAA+B;IAC/B,0CAA0C;IAC1C,uCAAuC;IACvC,mBAAmB;IACnB,qBAAqB;EACvB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,qEAAqE;EACvE","sourcesContent":["\n.grid {\n  \n    display : grid;\n    grid-template-columns: auto 1fr;\n    column-gap : var( --size-padMedium, 16px );\n    row-gap : var( --size-padMedium, 16px );\n    align-items: center;\n    justify-content: left;\n  }\n  \n  .fill {\n    grid-column: 1 / span 2;\n  }\n  \n  .sub {\n    padding : var( --size-padMedium, 16px ) var( --size-padXLarge, 32px );\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"grid": `grid_V5Y_x`,
	"fill": `fill_ot9Gp`,
	"sub": `sub__0AyV`
};
export default ___CSS_LOADER_EXPORT___;
